import { Modal } from "@msys/ui";
import { List, ListItem, ListItemText, Stack, Typography } from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { PimProductPreferenceScope } from "../../../../clients/graphqlTypes.js";
import { useUserData } from "../../../auth/useUserData.js";
import { BrandPreferenceOption } from "../brandPreferenceOptions.js";
import { organisationPermissionReason } from "../buttons/PreferenceMoveButton.js";

interface Props {
  picked: BrandPreferenceOption[];
  handleClose: () => void;
  onChoose: (scope: PimProductPreferenceScope) => void;
}

/** The scope is chosen by name after picking, once for the whole selection. */
export function PreferenceScopeModal({ picked, handleClose, onChoose }: Props) {
  const { t } = useTranslate(["Product", "Global"]);
  const { hasOrganisationPermission } = useUserData();
  const canWriteOrganisationScope = hasOrganisationPermission(
    "pim_catalogue_update"
  );

  const choose = (scope: PimProductPreferenceScope) => {
    onChoose(scope);
    handleClose();
  };

  return (
    <Modal
      title={t("Prefer selected brands", { ns: "Product" })}
      handleClose={handleClose}
      actionButtons={[
        {
          label: t("Cancel", { ns: "Global" }),
          handleClick: handleClose,
          buttonProps: { variant: "text" },
        },
        {
          label: t("For me", { ns: "Product" }),
          handleClick: () => choose("USER"),
          buttonProps: { variant: "outlined" },
        },
        {
          label: t("Organisation-wide", { ns: "Product" }),
          handleClick: () => choose("ORGANISATION"),
          buttonProps: { disabled: !canWriteOrganisationScope },
        },
      ]}
    >
      <Stack direction="column" spacing={1}>
        <List dense disablePadding>
          {picked.map(option => (
            <ListItem key={option.id} disableGutters>
              <ListItemText primary={option.name} />
            </ListItem>
          ))}
        </List>
        {!canWriteOrganisationScope ? (
          <Typography variant="body2" sx={{ color: "grey.600" }}>
            {organisationPermissionReason(t)}
          </Typography>
        ) : null}
      </Stack>
    </Modal>
  );
}
